module.exports = __webpack_public_path__ + "static/media/1009186.40fabbd8.png";